import React from 'react';

import BuyDirectPrice from 'components/BuyDirectPrice';
import ShowEndingSoon from 'components/badges/ShowEndingSoon';

const CardAuctionStatus = ({ bdp, auctionId, showBdp, timer }) =>
  showBdp ? <BuyDirectPrice bdp={bdp} auctionId={auctionId} /> : <ShowEndingSoon timer={timer} />;

export default CardAuctionStatus;
